import Analytics from './analytics'
import Invew from './inview'

new Analytics()
window.addEventListener('load',() => {
  document.body.classList.add('is-loaded')
  new Invew()
})

